/* eslint-disable warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Controller from '@ember/controller';
import { isEmpty } from '@ember/utils';
import { action } from '@ember/object';
import EnrolmentLogResource from 'linced-admin/enums/enrolment-log-resource';

export default class EnrolmentsController extends Controller {
  @action
  setSchoolSearchText(value) {
    this.schoolSearchText = value;
  }

  @tracked
  schoolSearchText;

  // Attrs
  queryParams = ['jurisdiction', 'resource', 'schoolId', 'duration'];

  // Services
  @service
  store;

  // Default State
  EnrolmentLogResource = EnrolmentLogResource;

  jurisdiction = null;
  resource = null;
  @tracked
  duration = '15';
  @tracked schoolId = null;
  @tracked
  resultDialogOpen = false;
  @tracked
  result = null;
  @tracked
  resultLoading = false;

  // methods
  get selectedSchool() {
    if (isEmpty(this.schoolId)) {
      return null;
    }

    let schools = this.model.schools.filter((school) => {
      return school.id === this.schoolId;
    });

    if (schools.length > 0) {
      return schools[0];
    }

    return null;
  }

  // durations provides the list of durations to offer in the dropdown.
  durations = [
    { value: '15', label: '15 minutes' },
    { value: '60', label: '1 hour' },
    { value: '1440', label: '1 day' },
    { value: '10080', label: '1 week' },
    { value: '43200', label: '30 days' },
    { value: '129600', label: '90 days' },
    { value: '262080', label: '6 months' },
    { value: '525600', label: '1 year' },
  ];

  /**
   * setSchool binds the selected school's id as a query param to filter logs.
   *
   * @param {Object} school - contains a school model.
   */
  @action
  setSchool(school) {
    if (isEmpty(school)) {
      this.schoolId = null;
      return;
    }

    this.schoolId = school.id;
  }

  /**
   * setDuration binds the selected duration as a query param to filter logs.
   *
   * @param {Object} duration - contains the selected duration object.
   */
  @action
  setDuration(duration) {
    this.duration = duration.value;
  }

  /**
   * showResult displays a dialog with the result associated with a log entry.
   *
   * @param {Object} logEntry - the log entry whose result should be shown.
   */
  @action
  showResult(logEntry) {
    let loading = true;
    if (isEmpty(logEntry.resourceId)) {
      loading = false;
    } else {
      let resource = '';
      switch (logEntry.resource) {
        case EnrolmentLogResource.IDENTIFIERS:
          resource = 'identifier';
          break;

        case EnrolmentLogResource.ENROLMENTS:
          resource = 'enrolment';
          break;

        case EnrolmentLogResource.UNENROLMENTS:
          resource = 'unenrolment';
          break;
      }

      if (isEmpty(resource)) {
        loading = false;
      } else {
        this.store
          .findRecord(`enrolments/${resource}`, logEntry.resourceId)
          .then((entity) => {
            this.result = entity;
            this.resultLoading = false;
          });
      }
    }

    this.resultDialogOpen = true;
    this.resultLoading = loading;
    this.result = null;
  }

  @action
  closeResultDialog() {
    this.resultDialogOpen = false;
  }
}
